import { get } from './api';

export const fetchEvents = ({ id }) => get(`/admin/booklets/${id}/reactions`);



// WEBPACK FOOTER //
// ./src/services/eventsApi.js